export default {
  plus: "action.add",
  "checkbox-checked": "action.checkbox-checked",
  "checkbox-unchecked": "action.checkbox-unchecked",
  clear: "action.clear",
  close: "action.close",
  clipboard: "action.copy",
  download: "action.download",
  editable: "action.edit",
  "badge-icon": "action.expand",
  "external-link": "action.external-link",
  link: "action.link",
  logout: "action.logout",
  maximize: "action.maximize",
  minimize: "action.minimize",
  "play-video": "action.play",
  "radio-unchecked": "action.radio-deselected",
  "radio-checked": "action.radio-selected",
  "action.table-sort-default": "action.expand",
  "table-sort-default": "action.expand",
  "table-sort-ascending": "action.table-sort-ascending",
  "table-sort-descending": "action.table-sort-descending",
  "icon-reorder": "action.reorder",
  trash: "action.trash",

  code: "content.code",
  color: "content.color",
  "text-file": "content.file-document",
  "graphic-file": "content.file-graphic",
  "icon-file": "content.file",
  "icon-font": "content.font",
  "icon-guide": "content.guide",
  "icon-heading": "content.heading",
  "big-kit": "content.kit",
  kit: "content.kit",
  "icon-text": "content.note",
  "icon-support-image": "content.supporting-image",
  version: "content.version",

  "empty-section": "empty-state.assets",

  building: "info.building",
  "checkmark-circle": "info.check-circle",
  checkmark: "info.checkmark",
  info: "info.info",
  error: "info.error",
  warning: "info.warning",
  "warning-filled": "info.warning",
  "globe-lock": "info.globe-lock",
  globe: "info.globe",
  lock: "info.lock-closed",
  "lock-fill": "info.lock-open",
  "lock-open": "info.lock-open",
  spinner: "info.spinner",
  "star-filled": "info.star-filled",
  star: "info.star",

  logo: "logo.full",
  brandmark: "logo.mark",
  "store-logo": "logo.store",

  "icon-asset-library": "marketing.asset-library",
  "icon-design-system": "marketing.design-system",
  "icon-distribution": "marketing.distribution",
  "icon-enterprise-security": "marketing.security",
  "icon-storage": "marketing.storage",
  "icon-style-guide": "marketing.style-guide",
  "icon-enterprise-support": "marketing.support",
  "icon-enterprise-terms": "marketing.terms",
  "icon-curation": "content.guide",
  "icon-usage": "marketing.usage",

  "triangle-collapsed": "navigation.chevron-right",
  "triangle-expanded": "navigation.chevron-down",
  "triangle-double": "action.expand",
  "triangle-double-small": "action.expand_16",
  "arrow-down": "navigation.chevron-down",
  "arrow-left": "navigation.chevron-left",
  "arrow-right": "navigation.chevron-right",
  "triangle-left": "navigation.chevron-left",
  "triangle-right": "navigation.chevron-right",
  "arrow-right-full": "navigation.chevron-right",

  billing: "navigation.credit-card",
  overview: "navigation.kit-menu",
  "layout-detailed": "navigation.layout-detailed",
  "layout-simple": "navigation.layout-simple",
  mail: "navigation.mail",
  menu: "navigation.menu",
  overflow: "navigation.overflow",
  eye: "navigation.privacy",
  search: "navigation.search",
  settings: "navigation.settings",
  users: "navigation.user-group",
  user: "navigation.user",
  profile: "navigation.user",

  facebook: "social.facebook",
  instagram: "social.instagram",
};
